import * as yup from "yup";

export const emailValidationSchema = yup.object().shape({
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      "Invalid email"
    ),
});

export const passwordvalidationSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Z])(?=.*[@$!%*#?&])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
      "Invalid Password."
    ),
});

export const resetPasswordValidationScehma = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Z])(?=.*[@$!%*#?&])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
      "A minimum 8 characters password contains a combination of uppercase and lowercase letter and number are required."
    ),
  confirmPassword: yup
    .string()
    .required("confirm password required")
    .oneOf([yup.ref("password"), null], "Password do not Match"),
});

export const addDepotFormValidationSchema = yup.object().shape({
  depotName: yup.string().required("Depot Name is required"),
  depotCode: yup.string().required("Depot code is required").max(3),
  street: yup.string().required("Street is required"),
  town: yup.string().required("Town is required"),
  country: yup.string().required("Country is required"),
  // .matches(/^[A-Za-z]+$/,"Only alphabets allowed"),
  postcode: yup.string().required("Postcode is required"),
  intSpace: yup.string().required("Interior space is required"),
  extSpace: yup.string().required("Exterior space is required"),
});

export const finalDeliveryModalValidationSchema = yup.object().shape({
  receiverName: yup.string().required("Receiver name is required"),
  receiverPosition: yup.string().required("Receiver position is required"),
  receiverPhone: yup
    .string()
    // .number('Only numbers allowed')
    .required("Phone is required")
    .matches(/^[0-9 -]*$/, "Only numbers allowed"),

  // .typeError('Only numbers allowed'),
});

export const addDepotPersonalFormValidationSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  street: yup.string().required("Street is required"),
  town: yup.string().required("Town is required"),
  country: yup.string().required("Country is required"),
  postcode: yup.string().required("Postcode is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      "Invalid email"
    ),
  phone: yup
    .string()
    // .number('Only numbers allowed')
    .required("Phone is required")
    .matches(/^[0-9 -]*$/, "Only numbers allowed"),

  // .typeError('Only numbers allowed'), // Add typeError for type validation
  // .matches(/^\+?[0-9]+$/, 'Invalid phone number'),
  // .matches(/^(0|\+91)?(\s?\d{1,})$/,"Enter a valid number")
});

export const addClientFormValidationSchema = yup.object().shape({
  clientName: yup.string().required("Client name is required"),
  street: yup.string().required("Street is required"),
  town: yup.string().required("Town is required"),
  country: yup.string().required("Country is required"),
  postcode: yup.string().required("Postcode is required"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      "Invalid email"
    ),
  phone: yup
    .string()
    // .number('Only numbers allowed')
    .required("Phone is required")
    .matches(/^[0-9 -]*$/, "Only numbers allowed"),

  // .typeError('Only numbers allowed'),
});

export const addProjectManagerFormValidationSchema = yup.object().shape({
  client: yup.string().required("Client selection is required"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      "Invalid email"
    ),
  phone: yup
    .string()
    // .number('Only numbers allowed')
    .required("Phone is required")
    .matches(/^[0-9 -]*$/, "Only numbers allowed"),

  // .typeError('Only numbers allowed'),
  // .matches(/^\+?[0-9]+$/, 'Invalid phone number'),
});

export const addDispatchOrderValidationSchema = yup.object().shape({
  client: yup.string().required("Client selection is required"),
  project: yup.string().required("Project selection is required"),
  projectManager: yup
    .string()
    .required("Project manager selection is required"),
  // name: yup
  //   .string()
  //   .required("Name is required"),
  // email: yup
  //   .string()
  //   .required("Email is required")
  //   .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Invalid email"),
  // phone: yup
  // .string()
  // .required("Phone is required")
  // .matches(/^[0-9 -]*$/, "Only numbers allowed")
});

export const addGoodsInFormValidationSchema = yup.object().shape({
  depotName: yup.string().required("Depot selection is required"),
  depotManagerName: yup
    .string()
    .required("Depot manager selection is required"),
  client: yup.string().required("Client selection is required"),
  project: yup.string().required("Project selection is required"),
  projectManager: yup
    .string()
    .required("Project manager selection is required"),
  vrn: yup.string().required("vrn is required"),
  driverName: yup.string().required("Driver field is required"),
  // internalSpaceOccupied: yup.string().required("Internal space is required"),
  // externalSpaceOccupied: yup.string().required("External space is required"),
  driverContact: yup
    .string()
    // .number('Only numbers allowed')
    .required("Enter valid number and only numbers allowed")
    .matches(/^[0-9 -]*$/, "Only numbers allowed"),

  // .typeError('Only numbers allowed'),
});

export const addProjectFormValidationSchema = yup.object().shape({
  projectName: yup.string().required("Project name is required"),
  intSpacep1: yup.number().typeError("Please enter a valid number").required(),
  street: yup.string().required("Street is required"),
  town: yup.string().required("Town is required"),
  country: yup.string().required("Country is required"),
  postcode: yup.string().required("Postcode is required"),
  extSpacep1: yup.number().typeError("Please enter a valid number").required(),
});
